/* eslint-disable indent */
import React, { useCallback, useEffect, useState } from "react";
import stylesPc from "./Header.module.css";
import stylesSp from "./Header_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import NavButton from "../../../../common/components/button/NavButton";
import { HeaderLogo } from "./HeaderLogo";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../../../RootReducer";
import { Avatar, createStyles, makeStyles, Slide, Theme } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import EditAdminPage from "../../../../admin/viewer/EditAdminPage";
import Typography from "@material-ui/core/Typography";
import { useMsal } from "@azure/msal-react";
import OnLeaveDialog from "../../../../common/components/dialog/OnLeaveDialog";
import EditProfileImage from "../../../../common/components/modal/EditProfileImage";
import { isAdmin, isEditor } from "../../../../utils/LogicUtils";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import classNames from "classnames";
import { useHistory, useLocation } from "react-router-dom";
import ContentSearch from "../../../../../src/viewer/search/components/ContentSearch";
import { DeleteTempFile } from "../../../../store/actions/SlideActions";
import { Clear, Dehaze } from "@material-ui/icons";
import { changeMenu } from "./HeaderActions";
import cineonhubLogoWhite from "../../../../assets/image/cineonhub_change.svg";
import cineonstudioLogoWhite from "../../../../assets/image/cineonstudio_change.svg";
import UploadVideo from "../../../../admin/viewer/UploadVideo";
import UploadFootage from "../../../../admin/viewer/UploadFootageMobile";
import CustomMediaRecorder from "../../../../viewer/index/components/mediaRecorder/CustomMediaRecorder";
import VideoUploadIcon from "../../../../assets/icon/VideoUploadIcon";
import SlideUploadIcon from "../../../../assets/icon/SlideUploadIcon";
import RecIcon from "../../../../assets/icon/RecIcon";
import SettingIcon from "../../../../assets/icon/SettingIcon";
import PuiTypography from "../../../../components/elements/PuiTypography";
import { DeleteMediaRecorderVideoFile } from "../../../../common/video/VideoActions";

/**
|--------------------------------------------------
| 共通ヘッダー画面
|--------------------------------------------------
*/
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        divider: {
            width: "2px",
        },
        avatar: {
            margin: "0px -9px 0 13px",
            width: "50px",
            height: "50px",
            cursor: "pointer",
        },
        signoutButton: {
            fontFamily: "noto-sans-cjk-jp",
            border: "none",
            backgroundColor: "#363B41",
            width: "220px",
            height: "40px",
            fontSize: "14px",
            "&:hover": {
                backgroundColor: "#3F454D",
                color: "var(--white)",
            },
        },
        recorderButton: {
            padding: "0",
            "& .MuiButton-label": {
                display: "flex",
                height: "100%",
            },
        },
    })
);

function Header() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const classes = useStyles();

    const { user, userInfo, header } = useSelector((state: AppState) => ({
        user: state.user.user,
        userInfo: state.user.userInfo,
        header: state.header,
    }));

    const dispatch = useDispatch();
    const history = useHistory();
    // tempFileデータをStoreから取得
    const { tempFile, mediaRecorderVideoFile } = useSelector((state: AppState) => ({
        tempFile: state.slide.tempFile,
        mediaRecorderVideoFile: state.video.mediaRecorderVideoFile,
    }));

    const { instance } = useMsal();

    //モーダル画面
    const [isOpenUserInfoModal, ShowUserInfoModal] = useState(false);
    const [isOpenAdminModal, ShowUserAdminModal] = useState(false);
    const [adminModalContentType, setAdminModalContentType] = useState<string>("management");
    const [isSaved, setIsSaved] = useState<boolean>(true);
    const [openDialog, setOpenDialog] = useState(false);
    //SP時ドロワーメニューopenフラグ
    const [isOpenDrawerMenu, ChangeOpenDrawerMenu] = useState<boolean>(false);

    //SP時アップロード画面openフラグ
    const [isOpenUploadModal, ChangeIsOpenUploadModal] = useState<boolean>(false);

    const [isUploadMessage, setIsUploadMessage] = useState<boolean>(false);
    const [isSlideUploadMessage, setIsSlideUploadMessage] = useState<boolean>(false);
    const [isRecMessage, setIsRecMessage] = useState<boolean>(false);
    const [isSettingMessage, setIsSettingMessage] = useState<boolean>(false);

    const OpenUserInfoModal = () => {
        ShowUserInfoModal(true);
    };

    const CloseUserInfoModal = () => {
        ShowUserInfoModal(false);
        setIsUploadMessage(false);
        setIsSlideUploadMessage(false);
        setIsRecMessage(false);
        setIsSettingMessage(false);
    };

    const OpenAdminModal = (contentType: string) => {
        CloseUserInfoModal();
        ShowUserAdminModal(true);
        setAdminModalContentType(contentType);
    };
    const { pathname } = useLocation();

    // ページ遷移かTempFileがあるか表示フラグ定義
    const [showDialogMsg, setShowDialogMsg] = useState(false);
    const CloseAdminModal = () => {
        if (isSaved) {
            ShowUserInfoModal(false);
            ShowUserAdminModal(false);
        } else {
            if (tempFile.keyName !== "") {
                setShowDialogMsg(true);
            }
            setOpenDialog(true);
        }
    };

    // ロクアウト
    const Logout = () => {
        localStorage.clear();
        instance.logout();
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setShowDialogMsg(false);
    };

    const handleCancel = () => {
        handleCloseDialog();
    };

    const handleConfirm = () => {
        if (tempFile.keyName !== "") {
            // tempFileデータをクリアする
            dispatch(DeleteTempFile(tempFile.keyName));
        }
        setIsSaved(true);
        ShowUserInfoModal(false);
        ShowUserAdminModal(false);
        ChangeIsOpenUploadModal(false);
        handleCloseDialog();
        dispatch(DeleteMediaRecorderVideoFile());
    };

    // cineonhub、cineonstudioの切り替え
    const handleSwitchService = () => {
        // cineonstudioにいる場合、cineonhubへ遷移する
        let path = "/homepage";
        if (!pathname.startsWith("/studio/")) {
            // cineonhubにいる場合、cineonstudioへ遷移する
            path = "/studio/homepage";
        }
        history.push(path);
        dispatch(changeMenu(header.to, path, ""));
    };

    const globalMenuData = {
        cineon: [
            {
                name: "コンテンツ",
                path: "/contents",
                // icon: <><VideoIcon color="secondary"/></>
            },
            {
                name: "チャンネル",
                path: "/channel",
                // icon: <><ProgramIcon color="secondary"/></>
            },
            {
                name: "プレゼンター",
                path: "/presenters",
                // icon: <><PresenterIcon color="secondary"/></>
            },
        ],
        cineonstudio: [
            {
                name: "ホーム",
                path: "/studio/homepage",
                // icon: <><VideoLibrary color="secondary"/></>
            },
            {
                name: "ライブラリ",
                path: "/studio/createdVideo",
                // icon: <><VideoLibrary color="secondary"/></>
            },
        ],
    };

    const cineonGlobalMenu = (
        <>
            {/* PC版以外のサーチ */}
            {!IsDevice("desktop") && <ContentSearch changeOpenDrawerMenu={ChangeOpenDrawerMenu} />}

            {globalMenuData.cineon.map((menu, index) => (
                <div
                    key={index}
                    className={styles.globalMenu}
                    onClick={() => {
                        !IsDevice("desktop") ? ChangeOpenDrawerMenu(!isOpenDrawerMenu) : void 0;
                    }}
                >
                    <NavButton
                        color="white"
                        path={menu.path}
                        // icon={menu.icon}
                    >
                        {menu.name}
                    </NavButton>
                </div>
            ))}

            {/* PC版サーチ */}
            {IsDevice("desktop") && <ContentSearch />}
        </>
    );

    // const cineonstudioGlobalMenu = (
    //     <>
    //         {globalMenuData.cineonstudio.map((menu, index) => (
    //             <div
    //                 key={index}
    //                 className={styles.globalMenu}
    //                 onClick={() => {
    //                     !IsDevice("desktop") ? ChangeOpenDrawerMenu(!isOpenDrawerMenu) : void 0;
    //                 }}
    //             >
    //                 <NavButton
    //                     color="white"
    //                     path={menu.path}
    //                     // icon={menu.icon}
    //                 >
    //                     {menu.name}
    //                 </NavButton>
    //             </div>
    //         ))}
    //     </>
    // );

    const globalMenu = (
        <>
            {/* cineonhub、cineonstudioのメニュー切り替え */}
            {pathname.startsWith("/studio/") ? (
                <>
                    {/* cineonstudioのPC、SPの共通のメニュー */}
                    {/* {cineonstudioGlobalMenu} */}
                </>
            ) : (
                <>
                    {/* cineonhubのPC、SPの共通のメニュー */}
                    {cineonGlobalMenu}
                </>
            )}
        </>
    );

    const closeUploadModal = () => {
        if (!isSaved) {
            setOpenDialog(true);
        } else {
            ChangeIsOpenUploadModal(false);
        }
    };

    const startCapture = () => {
        const startCaptureButton = document.getElementById("startCaptureButton");
        if (startCaptureButton) startCaptureButton.click();
    };

    useEffect(() => {
        if (mediaRecorderVideoFile) setIsSaved(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaRecorderVideoFile]);

    const handleScroll = useCallback(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const header = document.getElementById("header");
        const headerHeight = header?.offsetHeight;
        if (headerHeight && scrollTop > 0) {
            header?.classList.add("isActive");
        } else {
            header?.classList.remove("isActive");
        }
    }, []);

    useEffect(() => {
        document.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            document.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll]);

    return (
        // ロゴ
        <header
            className={classNames(styles.header, {
                [styles.headerColor]: !pathname.startsWith("/homepage") || header.scrollTop > 0,
            })}
            id="header"
        >
            <HeaderLogo />
            {/* ホームページ */}
            {IsDevice("desktop") ? (
                <div className={styles.headerLeft}>
                    {/* cineonhub、cineonstudioの切り替え */}
                    {globalMenu}

                    {/* 録画 */}
                    {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                        <CustomMediaRecorder openAdminModal={OpenAdminModal} />
                    )}
                </div>
            ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                        onClick={() => ChangeOpenDrawerMenu(!isOpenDrawerMenu)}
                        className={styles.openDrawerIcon}
                    >
                        <Dehaze />
                    </div>
                    <Slide direction="left" in={isOpenDrawerMenu} mountOnEnter unmountOnExit>
                        <div className={styles.drawerMenu}>
                            <div onClick={() => ChangeOpenDrawerMenu(false)}>
                                <Clear />
                            </div>

                            {/* cineonhub、cineonstudioの切り替え */}
                            {globalMenu}
                            <div
                                onClick={() => ChangeIsOpenUploadModal(true)}
                                className={styles.upload}
                            >
                                cineonhubへアップロード
                            </div>
                            <UploadFootage />
                            <div onClick={Logout} className={styles.drawerSignout}>
                                サインアウト
                            </div>
                        </div>
                    </Slide>
                </div>
            )}

            {/* PC版表示 */}
            {IsDevice("desktop") && (
                <div className={styles.headerRight}>
                    {/* サービスの切り替え */}
                    {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                        <div className={styles.btnServiceSwitch} onClick={handleSwitchService}>
                            <div className={styles.logo}>
                                {pathname.startsWith("/studio/") ? (
                                    <img
                                        src={cineonhubLogoWhite}
                                        // onMouseOver={(e) =>
                                        //     (e.currentTarget.src = cineonhubLogoHover)
                                        // }
                                        // onMouseOut={(e) =>
                                        //     (e.currentTarget.src = cineonhubLogoWhite)
                                        // }
                                        alt="cineonhub"
                                    />
                                ) : (
                                    <img
                                        src={cineonstudioLogoWhite}
                                        // onMouseOver={(e) =>
                                        //     (e.currentTarget.src = cineonstudioLogoHover)
                                        // }
                                        // onMouseOut={(e) =>
                                        //     (e.currentTarget.src = cineonstudioLogoWhite)
                                        // }
                                        alt="cineonstudio"
                                    />
                                )}
                            </div>
                        </div>
                    )}

                    {/* アバター */}
                    {userInfo?.imageUrl && (
                        <img
                            alt="アバター"
                            className={styles.profile}
                            src={userInfo?.imageUrl}
                            onError={(e) =>
                                (e.currentTarget.src = require("../../../../assets/image/noPresenterImage.svg"))
                            }
                            onClick={OpenUserInfoModal}
                        />
                    )}
                </div>
            )}

            {/* ユーザ情報表示モーダル */}
            <Modal
                open={isOpenUserInfoModal}
                onClose={CloseUserInfoModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <>
                    <Card
                        className={styles.userInfoModal}
                        style={{ backgroundColor: "#292E36", border: "none" }}
                    >
                        <CardContent
                            className={styles.userInfoModalItem}
                            style={{
                                display: "flex",
                                height: "90px",
                                padding: "20px",
                                backgroundColor: "#24282E",
                            }}
                        >
                            <div className={styles.profile}>
                                {userInfo?.imageUrl ? (
                                    <Avatar
                                        src={userInfo?.imageUrl}
                                        className={classes.avatar}
                                    ></Avatar>
                                ) : (
                                    <Avatar className={classes.avatar}></Avatar>
                                )}
                                <EditProfileImage
                                    userid={userInfo?.id}
                                    fullname={userInfo?.fullName}
                                    organization={userInfo?.organization}
                                    localAccountId={userInfo?.localAccountId}
                                    onClose={CloseUserInfoModal}
                                />
                                <div className={styles.text}>
                                    <PuiTypography size={16}>{userInfo?.fullName}</PuiTypography>
                                    <Typography
                                        data-tip={userInfo?.email}
                                        data-for="email"
                                        variant="body2"
                                        className={styles.string}
                                        style={{
                                            color: "#9c9c9c",
                                            fontSize: "14px",
                                            marginTop: "1px",
                                        }}
                                    >
                                        {userInfo?.email}
                                    </Typography>
                                </div>
                            </div>
                        </CardContent>
                        <CardActions className={styles.buttonDiv}>
                            {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                                <ul className={styles.buttonDivTop}>
                                    <li>
                                        <div
                                            className={styles.button}
                                            onClick={() => OpenAdminModal("video")}
                                            onMouseEnter={() => setIsUploadMessage(true)}
                                            onMouseLeave={() => setIsUploadMessage(false)}
                                        >
                                            <VideoUploadIcon />
                                        </div>
                                        {isUploadMessage && (
                                            <div
                                                className={styles.hoverStatusButton}
                                                style={{ top: "220px", right: "138px" }}
                                            >
                                                <PuiTypography color="black" size={14}>
                                                    動画アップロード
                                                </PuiTypography>
                                            </div>
                                        )}
                                    </li>
                                    <li>
                                        <div
                                            className={styles.button}
                                            onClick={() => OpenAdminModal("slidestock")}
                                            onMouseEnter={() => setIsSlideUploadMessage(true)}
                                            onMouseLeave={() => setIsSlideUploadMessage(false)}
                                        >
                                            <SlideUploadIcon />
                                        </div>
                                        {isSlideUploadMessage && (
                                            <div
                                                className={styles.hoverStatusButton}
                                                style={{ top: "220px", right: "3px" }}
                                            >
                                                <PuiTypography color="black" size={14}>
                                                    スライドアップロード
                                                </PuiTypography>
                                            </div>
                                        )}
                                    </li>
                                    <li>
                                        <div
                                            className={`${styles.button} ${classes.recorderButton}`}
                                            onClick={startCapture}
                                            onMouseEnter={() => setIsRecMessage(true)}
                                            onMouseLeave={() => setIsRecMessage(false)}
                                        >
                                            <RecIcon />
                                        </div>
                                        {isRecMessage && (
                                            <div
                                                className={styles.hoverStatusButton}
                                                style={{ top: "320px", right: "176px" }}
                                            >
                                                <PuiTypography color="black" size={14}>
                                                    録画
                                                </PuiTypography>
                                            </div>
                                        )}
                                    </li>
                                    <li>
                                        <div
                                            className={styles.button}
                                            onClick={() => OpenAdminModal("management")}
                                            onMouseEnter={() => setIsSettingMessage(true)}
                                            onMouseLeave={() => setIsSettingMessage(false)}
                                        >
                                            <SettingIcon />
                                        </div>
                                        {isSettingMessage && (
                                            <div
                                                className={styles.hoverStatusButton}
                                                style={{ top: "320px", right: "56px" }}
                                            >
                                                <PuiTypography color="black" size={14}>
                                                    管理
                                                </PuiTypography>
                                            </div>
                                        )}
                                    </li>
                                </ul>
                            )}
                            <Button
                                size="small"
                                variant="outlined"
                                style={{
                                    display: "block",
                                    color: "var(--loading-bg)",
                                    border: "none",
                                    marginLeft: "0",
                                }}
                                onClick={Logout}
                                className={classes.signoutButton}
                            >
                                サインアウト
                            </Button>
                        </CardActions>
                    </Card>
                    <PuiTooltip id={"email"} />
                </>
            </Modal>
            <Modal
                open={isOpenUploadModal}
                onClose={closeUploadModal}
                className={styles.uploadModal}
            >
                <>
                    <UploadVideo
                        isSaved={isSaved}
                        setIsSaved={setIsSaved}
                        closeUploadModal={closeUploadModal}
                    />
                </>
            </Modal>

            {/* 管理画面モーダル */}
            <Modal
                className={styles.editAdminModal}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={isOpenAdminModal}
                onClose={CloseAdminModal}
                closeAfterTransition
            >
                <>
                    <EditAdminPage
                        in={isOpenAdminModal}
                        contentType={adminModalContentType}
                        onClose={CloseAdminModal}
                        isSaved={isSaved}
                        setIsSaved={setIsSaved}
                    />
                </>
            </Modal>

            <OnLeaveDialog
                openDialog={openDialog}
                dialogTitle={
                    showDialogMsg ? "コンテンツアップロード確認" : "ページを遷移しますか？"
                }
                dialogContent={
                    showDialogMsg
                        ? "現在アップロードしているコンテンツファイルは失われます"
                        : "ページを移動すると、変更内容は失われます"
                }
                dialogActions={"ページ移動"}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
            />
        </header>
    );
}

export default Header;
